import { BOrganizationItem } from '@pharmsnap/shared/components'
import { useRequest } from '@pharmsnap/shared/composition/useRequest'
import { sharedCtx } from '@pharmsnap/shared/context'
import { defineComponent, PropType, watch } from '@vue/composition-api'
import { BBasicLoadingCard } from '../BBasicLoadingCard/BBasicLoadingCard'
export const BOrganizationFetchListCard = defineComponent({
  name: 'BOrganizationFetchListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const { loading, data } = useRequest(
      {
        requestFn: sharedCtx.service.organization.getBatchOrg.bind(sharedCtx.service.organization),
      },
      props.ids
    )
    watch(loading, () => {
      ctx.emit('update')
    })
    return {
      loading,
      data,
    }
  },
  render() {
    return (
      <BBasicLoadingCard loading={this.loading}>
        <div class="flex flex-wrap">
          {this.data?.map((item) => {
            return <BOrganizationItem class="mr-1 mb-1" data={item} coreIds={this.coreIds}></BOrganizationItem>
          })}
        </div>
      </BBasicLoadingCard>
    )
  },
})
